import PropTypes from "prop-types";
import { atomTextAttributesPropType } from "./atom-text-attributes-prop-type";

export const occasionsBarPropType = PropTypes.shape({
  title: PropTypes.string,
  background: PropTypes.string,
  testClass: PropTypes.string,
  hedAttributes: atomTextAttributesPropType,
  listItems: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      image: PropTypes.string,
      imageAlt: PropTypes.string,
      label: PropTypes.string,
    })
  ).isRequired,
  paths: PropTypes.array,
});
